import React, {useState} from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

/**
 * Muestra un botón para subir ficheros
 *
 * ## PROPS
 * - **elementDnd** *object (useState)*   Ej: [{id: "1", content: "Item 1" }, {id: "2", content: "Item 2" }, {id: "1", content: "Item 3" }]
 * - **setElementDnd** *object (useState)*
 * - **direction** *string Ej: horizontal, vertical
 * - **showPosition** *boolean Ej: muestra posición del elemento
 */
export default function DndElements(props) {
    const {elementDnd, setElementDnd, direction,showPosition} = props

    const directionIn = direction ?? "horizontal";
    const showPositionIn = showPosition ?? false;


    const onDragEnd = (result) => {
        // Caído fuera de la lista
        if (!result.destination) {
            return;
        }

        const items = reorder(elementDnd, result.source.index, result.destination.index);

        setElementDnd(items)
    }

    let listStyle = {}
    if (directionIn === "horizontal") {
        listStyle = {
            display: 'flex',
            padding: grid,
            overflow: 'auto'
        }
    }
    const getListStyle = isDraggingOver => (listStyle);

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction={directionIn}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver, directionIn)}
                        {...provided.droppableProps}
                    >
                        {elementDnd.map((item, index) => (
                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                {(provided, snapshot) => (
                                    <>
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style
                                            )}
                                            className={`dnd-element`}
                                        >
                                             {showPosition && (
                                                <>
                                                    {index + 1}  {item.content}
                                                </>
                                            )}
                                            {!showPosition && (
                                                <>
                                                    {item.content}
                                                </>
                                            )}
                                            
                                           
                                        </div>
                                    </>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}

// Una pequeña función para ayudarnos a reordenar el resultado
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // algunos estilos básicos para que los artículos se vean un poco mejor
    userSelect: 'none',
    padding: 5,
    borderRadius:3,
    margin: `0 ${grid}px 0 0`,

    // cambiar el color de fondo si se arrastra
    background: isDragging ? 'lightgreen' : '#e5e5e5',

    // estilos que necesitamos aplicar en arrastrables
    ...draggableStyle
});

